import * as React from 'react';
import './TableChorinitia.css';

export interface Props {
    header: JSX.Element;
    children: JSX.Element;
    className?: string;
}

interface State {
}

export class TableChorinitia extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
    }

    render() {
        var laclasse = this.props.className === undefined ? '' : this.props.className;
        var classe = 'table table-striped table-bordered table-hover table-chorinitia ' + laclasse;
        return (
            <table className={classe}>
                {this.props.header}
                {this.props.children}
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/TableChorinitia/TableChorinitia.tsx